export default __webpack_public_path__ + "media/components/ui/Slider/carousel-prev-9ea527b102458dea5749473745925641.png";